import { Component, EventEmitter, ViewChild, Input, OnInit, Output } from '@angular/core';
import { ComponentBase } from '../../../_infrastructure/classes/componentBase';
import { HttpParams } from '@angular/common/http';
import { UntypedFormBuilder } from '@angular/forms';
import { Table } from 'primeng/table';
import { WBotanicaViewModel, WBotanicaExtendedItemResultsViewModel, EnumSiNoTodos } from 'src/app/components/core/_infrastructure/types/common';
import { GlobalService } from 'src/app/components/core/_infrastructure/classes/services/global.service';
import { GrupoFormaService } from 'src/app/components/_mantenimiento/especies/gruposformas/grupoforma.service';
import { Dialog } from 'primeng/dialog';
import { SelectItem } from 'primeng/api';

@Component({
    selector: 'app-especie-eppo-popup',
    templateUrl: './especieEppoPopup.component.html',
})
export class EspecieEppoPopupComponent extends ComponentBase implements OnInit {
    @Input() isModeSelectionRowsCheckBoxes = false; //FALSE --> SINGLE (doble clic), TRUE --> MULTIPLE (checkboxes)
    @Input() esImportacion = false;
    @Input() esExportacion = false;
    @Output() selected = new EventEmitter<WBotanicaViewModel>(); // emit para grid en modo selección doble clic en la fila a seleccionar
    @Output() selectedArray = new EventEmitter<WBotanicaViewModel[]>(); // emit para grid en modo selección checkboxes en las filas a seleccionar
    @ViewChild('tableSearch') turboTable: Table;

    listSiNoTodos: SelectItem[];
    resultEspecieEppo: WBotanicaExtendedItemResultsViewModel;
    display = false;
    cols: any[];

    selectedEspecieEppo: WBotanicaViewModel | null;
    arraySelectedEspeciesEppo: WBotanicaViewModel[] = [];
    modoConsulta = false;
    IdGrupo: number | null = null;
    IdForma = 0;
    IdSubForma: number | null = null;
    DescripcionGrupo: string;
    DescripcionForma: string;
    DescripcionSubForma: string;
    tooltipDescripcionGrupo: string;

    public existeParametroGrupo = false;
    public isCollapsed = false;

    constructor(private fb: UntypedFormBuilder, private globalService: GlobalService, private grupoformaService: GrupoFormaService) {
        super();
    }

    ngOnInit() {
        this.cols = [
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'CodigoEppo', header: 'Código Eppo' },
            { field: 'IdGrupoDescripcion', header: 'Grupo', display: 'none' },
            { field: 'IdNombreCientificoDescripcion', header: 'Nombre Botánico' },
            { field: 'NombreComun', header: 'Nombre Común' },
            { field: 'Favorito', header: 'Favorito' },
        ];

        this.form = this.fb.group({
            CodigoEppo: '',
            NombreBotanico: '',
            NombreComun: '',
            Favorito: EnumSiNoTodos.TODOS,
        });

        //p-selectButton
        this.listSiNoTodos = [
            { label: 'Sí', value: EnumSiNoTodos.SI },
            { label: 'NO', value: EnumSiNoTodos.NO },
            { label: 'TODOS', value: EnumSiNoTodos.TODOS },
        ];
    }

    onSearchButton(): void {
        if (this.turboTable) {
            this.turboTable.first = 0;
        }

        this.Search(0);

        this.searchingButton = true;
        this.isCollapsed = false;
    }

    Search(pageNumber: number, asc = 0, orderBy = ''): void {
        let params = new HttpParams();

        params = params.append('pageNumber', pageNumber.toString());
        params = params.append('asc', asc.toString());
        params = params.append('orderBy', orderBy);
        params = params.append('idGrupo', this.IdGrupo != null ? this.IdGrupo.toString() : '0');
        params = params.append('idForma', this.IdForma != null ? this.IdForma.toString() : '0');
        params = params.append('idSubForma', this.IdSubForma != null ? this.IdSubForma.toString() : '0');
        params = params.append('codigoeppo', this.form.value.CodigoEppo);
        params = params.append('nombreCientifico', this.form.value.NombreBotanico);
        params = params.append('nombreComun', this.form.value.NombreComun);
        params = params.append('favorito', this.form.value.Favorito);
        params = params.append('IsPopup', 'true');
        params = params.append('esImportacion', this.esImportacion);
        params = params.append('esExportacion', this.esExportacion);
        params = params.append('isInforme', this.isModeSelectionRowsCheckBoxes.valueOf() == true ? 'true' : 'false');

        this.loading = true;

        this.globalService.getWBotanicaExtendedPagedByFilter(params).subscribe(result => {
            if (result) {
                this.selectedEspecieEppo = null;
                this.resultEspecieEppo = result;
                this.loading = false;
            }
        });
    }

    onSearchLazy(event: any): void {
        if (!event.rows) {
            return;
        }

        let pageNumber = event.first / event.rows;

        this.Search(pageNumber, event.sortOrder, event.sortField);
    }

    onCleanButton(): void {
        this.form.setValue({
            CodigoEppo: '',
            NombreBotanico: '',
            NombreComun: '',
            Favorito: EnumSiNoTodos.TODOS,
        });

        this.searchingButton = false;
        this.isCollapsed = false;
        this.selectedEspecieEppo = null;
        this.arraySelectedEspeciesEppo = [];
        this.resultEspecieEppo = new WBotanicaExtendedItemResultsViewModel();
    }

    //idGrupo: Para Informe de Importaciones
    showDialog(idGrupo: number | null, idForma: number, idSubForma: number | null, isModeSelectionRowsCheckBoxes: boolean): void {
        this.display = true;
        //están también en onCleanButton()
        //this.isCollapsed = false;
        //this.searchingButton = false;

        //borra datos introducidos en llamadas anteriores en campos del formulario
        this.onCleanButton();

        this.DescripcionGrupo = '';
        this.DescripcionForma = '';
        this.DescripcionSubForma = '';
        this.IdGrupo = idGrupo;
        this.IdForma = idForma;
        this.IdSubForma = idSubForma;

        this.resultEspecieEppo = new WBotanicaExtendedItemResultsViewModel();

        this.isModeSelectionRowsCheckBoxes = isModeSelectionRowsCheckBoxes;

        if (this.IdGrupo != null) {
            this.existeParametroGrupo = true;
            this.grupoformaService.getGrupo(this.IdGrupo).subscribe(result => {
                if (result) {
                    this.DescripcionGrupo = ' Grupo: ' + result.Descripcion;
                }
            });
        }

        this.grupoformaService.getForma(idForma).subscribe(result => {
            if (result) {
                this.DescripcionForma = ' Forma: ' + result.Descripcion;
            }
            if (this.IdSubForma != null) {
                this.grupoformaService.getSubForma(this.IdSubForma).subscribe(result => {
                    if (result) {
                        this.DescripcionSubForma += ' SubForma: ' + result.Descripcion;
                    }
                });
            }
        });
    }

    //emit para grid en modo selección doble clic en la fila a seleccionar
    onRowDblClick(event: any, especieEppo: WBotanicaViewModel): void {
        this.display = false;
        this.searchingButton = false;
        this.selectedEspecieEppo = especieEppo;
        this.selected.emit(this.selectedEspecieEppo);
    }

    //emit para grid en modo selección checkboxes en las filas a seleccionar
    emitArraySelectedEspeciesEppo(event: any, arraySelectedEspeciesEppo: WBotanicaViewModel[]): void {
        this.display = false;
        this.searchingButton = false;

        //p-dialog es un contenedor que se oculta/muestra a demanda, por eso hay que borrar los datos obtenidos, ya que perduran.
        //Para que la siguiente vez al entrar no salgan marcados los checkbox en la tabla
        let arraySelectedEspeciesEppoNew = arraySelectedEspeciesEppo.slice();
        arraySelectedEspeciesEppo.splice(0, arraySelectedEspeciesEppo.length);
        this.selectedArray.emit(arraySelectedEspeciesEppoNew);
    }

    acceptDialog(): void {
        this.display = false;
        this.selected.emit(this.selectedEspecieEppo!);
    }

    cancelDialog(): void {
        this.display = false;
    }

    showDialogMaximized(dialog: Dialog): void {
        setTimeout(() => {
            dialog.maximize();
        }, 0);
    }

    onSelect(selection: WBotanicaViewModel): void {
        this.selectedEspecieEppo = selection;
    }

    noAccepted(): boolean {
        return (
            !this.form.valid ||
            (!this.isModeSelectionRowsCheckBoxes && !this.selectedEspecieEppo) ||
            (this.isModeSelectionRowsCheckBoxes && this.arraySelectedEspeciesEppo.length == 0)
        );
    }
}
